// reference from: https://dev.to/admitkard/auto-generate-avatar-colors-randomly-138j
const DEFAULT_SATURATION_RANGE = [40, 60];
const DEFAULT_LIGHTNESS_RANGE = [40, 60];

export function generateAvatarColorForName(name: string): string {
  return HSLtoString(
    generateHSL(name, DEFAULT_SATURATION_RANGE, DEFAULT_LIGHTNESS_RANGE)
  );
}

const HSLtoString = (hsl: number[]) => {
  return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
};

const generateHSL = (
  name: string,
  saturationRange: number[],
  lightnessRange: number[]
) => {
  const hash = getHashOfString(name);
  const h = normalizeHash(hash, 0, 360);
  const s = normalizeHash(hash, saturationRange[0], saturationRange[1]);
  const l = normalizeHash(hash, lightnessRange[0], lightnessRange[1]);
  return [h, s, l];
};

const getHashOfString = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    // tslint:disable-next-line: no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  hash = Math.abs(hash);
  return hash;
};

const normalizeHash = (hash: number, min: number, max: number) => {
  return Math.floor((hash % (max - min)) + min);
};
